import { Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { Player } from "@lottiefiles/react-lottie-player"
import animation from "../../../../../../shared/animations/succeededAnimation.json"
import { Box } from "@mui/system"
import { StandardDialog } from "../../../../../../shared/components/dialogs/StandardDialog"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { ManageBookingsAction } from "../manageBookingsTypes"

const useStyles = makeStyles()(() => ({
    title: {
        marginTop: "-3rem",
        paddingBottom: "2rem",
        textAlign: "center",
    },
    animationArea: {
        width: "10rem",
        height: "10rem",
        margin: "0 auto",
        marginBottom: "2rem",
    },
}))

type Props = Readonly<{
    open: boolean
    onClose: () => void
    action: ManageBookingsAction
}>

export function ManageBookingsSuccessDialog({ open, onClose, action }: Props) {
    const { classes } = useStyles()

    const isMove = action === ManageBookingsAction.CHANGE_ORGANIZER

    return (
        <StandardDialog open={open} onClose={onClose}>
            <LocalizedStrict
                id={
                    isMove
                        ? "service-center-admin-organization-manage-bookings-success-modal-move-title"
                        : "service-center-admin-organization-manage-bookings-success-modal-delete-title"
                }
            >
                <Typography variant="h4" className={classes.title}>
                    {isMove ? "Orders moved successfully" : "Orders deleted successfully"}
                </Typography>
            </LocalizedStrict>
            <Box className={classes.animationArea}>
                <Player src={animation} autoplay keepLastFrame />
            </Box>
        </StandardDialog>
    )
}
